import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  rewardRedemption: [],
  dailyCustomerPoint: [],
  subscribedCustomer: [],
  customers: [],
  offlineGoldPurchase: [],
  subscription: [],
  totalCount: 0,
};

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_REWARD_REDEEM_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "RewardRedemption fetch successfully",
        rewardRedemption: action.payload.data,
      };
    case TYPE.GET_REWARD_REDEEM_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching reward redemption",
        rewardRedemption: [],
      };
    case TYPE.GET_DAILY_CUSTOMER_POINT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "RewardRedemption fetch successfully",
        dailyCustomerPoint: action.payload.data,
      };
    case TYPE.GET_DAILY_CUSTOMER_POINT_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching reward redemption",
        dailyCustomerPoint: [],
      };
    case TYPE.GET_SUBSCRIBED_CUSTOMER_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Subscribed fetch successfully",
        subscribedCustomer: action.payload.data,
      };
    case TYPE.GET_SUBSCRIBED_CUSTOMER_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching Subscribed",
        subscribedCustomer: [],
      };
    case TYPE.GET_CUSTOMER_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Customers fetch successfully",
        customers: action.payload.data,
      };
    case TYPE.GET_CUSTOMER_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching customers",
        customers: [],
      };
    case TYPE.GET_OFFLINE_GOLD_TRANSACTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "offlineGoldPurchase fetch successfully",
        offlineGoldPurchase: action.payload.data,
      };
    case TYPE.GET_OFFLINE_GOLD_TRANSACTION_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching offlineGoldPurchase",
        offlineGoldPurchase: [],
      };
    // case TYPE.CLEAR_OFFLINE_GOLD_PURCHASE:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: false,
    //     message: "",
    //     offlineGoldPurchase: [],
    //   };
    case TYPE.GET_SUBSCRIPTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "subscription fetch successfully",
        subscription: action.payload.data,
      };
    case TYPE.GET_SUBSCRIPTION_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching subscription",
        subscription: [],
      };
    case TYPE.CLEAR_OFFLINE_GOLD_PURCHASE:
      return {
        ...state,
        rewardRedemption: [],
        dailyCustomerPoint: [],
        subscribedCustomer: [],
        customers: [],
        offlineGoldPurchase: [],
        subscription: [],
        totalCount: 0,
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default reportsReducer;
